export enum EOutsideTAInfrastructureType {
  busStops = 'busStopsOutside',
  tramStops = 'tramStopsOutside',
  metro = 'metroOutside',
  parking = 'parkingOutside',
  bikeParking = 'bikeParkingOutside',
  chargingStations = 'chargingStationsOutside',
  scooterParking = 'scooterParkingOutside',
  boulevards = 'boulevardsOutside',
}

export enum EInsideTAInfrastructureType {
  yardWithoutCars = 'yardWithoutCarsInside',
  parking = 'parkingInside',
  placeOfShortTransportStop = 'placeOfShortTransportStopInside',
  bikeParking = 'bikeParkingInside',
  chargingStations = 'chargingStationsInside',
  scooterParking = 'scooterParkingInside',
  boulevards = 'boulevardsInside',
  trafficSafetyElements = 'trafficSafetyElementsInside',
}

export type TTAInfrastructureType = EOutsideTAInfrastructureType | EInsideTAInfrastructureType;
